"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _RadialData2 = _interopRequireDefault(require("./RadialData"));

var oneSecond = 1000;
var lowThreshold = 5300;
var mediumThreshold = 7301;
var twentySeconds = 20000;
var twoHundred = 200;

var PageLoadingTimeRadialData =
/*#__PURE__*/
function (_RadialData) {
  (0, _inherits2.default)(PageLoadingTimeRadialData, _RadialData);

  function PageLoadingTimeRadialData() {
    (0, _classCallCheck2.default)(this, PageLoadingTimeRadialData);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PageLoadingTimeRadialData).apply(this, arguments));
  }

  (0, _createClass2.default)(PageLoadingTimeRadialData, [{
    key: "init",
    value: function init(grade) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(PageLoadingTimeRadialData.prototype), "init", this).call(this, grade);

      var seconds = _I18n.default.text('results.data.seconds');

      this.displayValueUnit = seconds;
      this.displayRecommendationValue = '< 5.3';
      this.displayRecommendationValueUnit = seconds;
    }
  }, {
    key: "setGradeType",
    value: function setGradeType(grade) {
      this.gradeType = this.getGoodOkBadGradeType(grade, lowThreshold, mediumThreshold);
    }
  }, {
    key: "setScore",
    value: function setScore(grade) {
      // E.g. 20 seconds = 100%, 1 second = 5%
      this.score = Math.round(Math.min(grade, twentySeconds) / twoHundred);
    }
    /**
     * Sets the displayValue and displayValueUnit.
     *
     * E.g.
     *
     *   grade = 5000
     *     displayValue = 5
     *     displayValueUnit = Sec
     *
     */

  }, {
    key: "setDisplayValue",
    value: function setDisplayValue(grade) {
      this.displayValue = Math.max(parseFloat((grade / oneSecond).toFixed(1)), 0.1);
    }
  }]);
  return PageLoadingTimeRadialData;
}(_RadialData2.default);

var _default = PageLoadingTimeRadialData;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/data/components/PageLoadingTimeRadialData.js
// module id = 268
// module chunks = 0